import React, { Component } from 'react'
import { BrowserRouter as Router, Route, Redirect, Switch } from 'react-router-dom'
import {
  redirectToLogin,
  refreshToken,
  isOutsideIframe,
  isAuth,
  checkIfIsLoopedLogin,
} from 'utils/auth'

import OAuthCallback from 'containers/OAuthCallback'
import PrivateRoute from 'components/PrivateRouter'
import ConfigurationsIndex from 'pages/ConfigurationsIndex'
import ConfigurationsEdit from 'pages/ConfigurationsEdit'
import ConfigurationsNew from 'pages/ConfigurationsNew'
import DevicesIndex from 'pages/DevicesIndex'
import DevicesEdit from 'pages/DevicesEdit'
import DevicesNew from 'pages/DevicesNew'
import PrintersIndex from 'pages/PrintersIndex'
import PrintersEdit from 'pages/PrintersEdit'
import PrintersNew from 'pages/PrintersNew'

export default class Routes extends Component {
  tokenRefreshIntervalId = null

  componentDidMount() {
    if (isOutsideIframe()) {
      if (isAuth()) {
        localStorage.removeItem('redirectToLoginAttemptedCheck')
        this.setTokenRefreshInterval(refreshToken)
      } else {
        checkIfIsLoopedLogin()
      }
    }
  }

  componentWillUnmount() {
    clearInterval(this.tokenRefreshIntervalId)
  }

  setTokenRefreshInterval = (callback) => {
    callback()
    this.tokenRefreshIntervalId = setInterval(() => callback(), 60000)
  }

  render() {
    return (
      <Router>
        <Switch>
          <Route component={OAuthCallback} exact path="/oauth/callback" />
          <Route exact path="/login" render={redirectToLogin} />
          <PrivateRoute component={ConfigurationsEdit} path="/configurations/:id/edit" />
          <PrivateRoute component={ConfigurationsNew} path="/configurations/new" />
          <PrivateRoute component={ConfigurationsIndex} path="/configurations" />
          <PrivateRoute component={DevicesEdit} path="/devices/:id/edit" />
          <PrivateRoute component={DevicesNew} path="/devices/new" />
          <PrivateRoute component={DevicesIndex} path="/devices" />
          <PrivateRoute component={PrintersEdit} path="/printers/:id/edit" />
          <PrivateRoute component={PrintersNew} path="/printers/new" />
          <PrivateRoute component={PrintersIndex} path="/printers" />
          <Route exact path="/" render={RedirectToConfigurations} />
        </Switch>
      </Router>
    )
  }
}

const RedirectToConfigurations = () => {
  return <Redirect to="/configurations" />
}
